import React, { Component } from 'react';
import { withStyles, Typography, ClickAwayListener, Grow, Paper, Popper } from '@material-ui/core';
import ReactSelect from '../../../../common/components/UI/Select/ReactSelect';
import InputNumber from '../../../../common/components/UI/Input/Number';
import CustomButton from '../../../../common/components/UI/Button/Button';
import { translate } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { exists, displayOrgpath, genDatePicker } from '../../../../common/utilities/utilitiesFunctions';
import { isNull } from 'util';
import { connect } from 'react-redux';
import moment from 'moment';
import clsx from 'clsx';

import { updateShiftLineMenuOpen } from '../actions'

const styles = theme => ({
    menuActions: {
        border: '1px solid #E6EDF5',
        borderRadius: '4px'
    },
    popover: {
        zIndex: 100
    },
    menuAddShiftLines: {
        width: 400,
        padding: 10,
        position: 'relative'
    },
    buttonEditShiftLineToolBar: {
        height: 36
    },
    dateTypo: {
        flex: '1',
        color: '#878787',
        fontSize: '12px'
    },
    divButtonApply: {
        width: '100%',
        textAlign: "end",
        paddingTop: 10
    },
    tableColumnButton: {
        width: 34,
        border: '1px solid #0A54A2',
        cursor: 'pointer',
        height: 34,
        display: 'inline-block',
        marginTop: 1,
        marginLeft: 10,
        paddingLeft: 10,
        paddingTop: 5,
        borderRadius: 4,
        backgroundColor: 'transparent',
        color: '#0A54A2'
    },
    disabledButton: {
        cursor: 'default',
        border: '1px solid #bdbdbd',
        color: '#bdbdbd'
    }
})

const dateFormat = 'YYYY-MM-DD';

class AddShiftLinesMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSchedulePatternTemplate: '',
            selectedOrgpath: '',
            repetition: 1,
            selectedStartDate: null,
            selectedEndDate: null
        }
        this.ref = React.createRef()
    }

    generateInputs = (labelTypo, placeholder, value, list, target, isClearable = true, disabled = false, SingleValue) => {
        const { classes } = this.props;

        const customSelectStylesTd = {
            control: contaner => ({
                marginBottom: 0
            }),
        }

        return (<React.Fragment>
            <Typography className={classes.dateTypo}>
                {labelTypo}
            </Typography>
            {exists(SingleValue) ?
                <ReactSelect
                    // labelText={labelTypo}
                    placeholder={placeholder}
                    value={typeof value !== 'undefined' ? value : ''}
                    options={list}
                    onChange={this.handleChangeSelect}
                    target={target}
                    isDisabled={disabled}
                    error={!isNull(value) && isNull(value.label)}
                    isClearable={isClearable}
                    components={{ SingleValue }}
                    style={{ customSelectStylesTd }}
                />
                :
                <ReactSelect
                    // labelText={labelTypo}
                    placeholder={placeholder}
                    value={typeof value !== 'undefined' ? value : ''}
                    options={list}
                    onChange={this.handleChangeSelect}
                    target={target}
                    isDisabled={disabled}
                    error={!isNull(value) && isNull(value.label)}
                    isClearable={isClearable}
                />}
        </React.Fragment>
        )
    }

    handleChangeSelect = (target, value) => {
        this.setState({ [target]: value });
    }

    handleChangedate = (value, target) => {
        this.setState({ [target]: value });
    }

    handleChangeLineNumber = (min, max, value) => {
        value = value >= max ? max : value;
        value = value <= min ? min : value;
        this.setState({ repetition: value })
    }

    addShiftLines = () => {
        const { selectedSchedulePatternTemplate, selectedOrgpath, repetition, selectedStartDate, selectedEndDate } = this.state;

        this.props.addShiftLines(selectedSchedulePatternTemplate, selectedOrgpath, repetition, selectedStartDate, selectedEndDate);
    }

    render() {
        const { buttonLabel, schedulePatternsTemplates, selectedWorkPlan, title, disableToolbar, classes, t, isOpen, updateShiftLineMenuOpen } = this.props;
        const { selectedSchedulePatternTemplate, selectedOrgpath, repetition, selectedStartDate, selectedEndDate } = this.state;
        const SingleValueOrgPath = ({ data, }) => { return (displayOrgpath(data.label, classes)); };
        let minDate, maxDate, minLines = 1, maxLines = 20;

        if (selectedWorkPlan.startDate !== null && selectedWorkPlan.startDate.substring(0, 10) !== "0001-01-01") {
            minDate = moment(selectedWorkPlan.startDate, dateFormat).isAfter(moment(), 'day') ? moment(selectedWorkPlan.startDate, dateFormat) : moment();
            maxDate = moment(selectedWorkPlan.endDate, dateFormat);

            if (selectedWorkPlan.states && selectedWorkPlan.states.length) {
                const stopState = selectedWorkPlan.states.find(x => x.status === 2);
                if (stopState) {
                    const stopEndDate = moment(stopState.endDate, dateFormat);
                    if (stopState && maxDate.isAfter(stopEndDate)) {
                        maxDate = stopEndDate.add(-1, 'days');
                    }
                }
            }
        }
        let minEndDate = selectedStartDate === null ? moment.utc() : selectedStartDate;

        return (
            <React.Fragment>
                <CustomToolTip enterDelay={500} leaveDelay={500} titletext={title} jsx={
                    <div ref={this.ref} className={clsx(classes.tableColumnButton, disableToolbar ? classes.disabledButton : '')} onClick={() => updateShiftLineMenuOpen(true)}>
                        <FontAwesomeIcon className={classes.icon} color={disableToolbar ? '#bdbdbd' : '#0A54A2'} icon={faPlus} />
                        <span>{buttonLabel}</span>
                    </div>
                } />
                <Popper
                    open={isOpen}
                    anchorEl={this.ref.current}
                    placement={'bottom-start'}
                    transition
                    className={classes.popover}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'right bottom',
                            }}
                        >
                            <Paper>
                                <span>
                                    <ClickAwayListener onClickAway={() => { updateShiftLineMenuOpen(false) }}>
                                        <div className={classes.menuAddShiftLines}>
                                            <div style={{ paddingBottom: 10 }}>
                                                <Typography className={classes.dateTypo}>
                                                    {this.props.t('workPlanView.addShiftLines.howManyLines')}
                                                </Typography>
                                                <InputNumber
                                                    min={minLines}
                                                    max={maxLines}
                                                    step={1}
                                                    precision={0}
                                                    value={repetition}
                                                    // error={timeValueERROR}
                                                    strict={false}
                                                    // label={'How many lines'}
                                                    target='numberPattern'
                                                    classNameContainer={classes.inputNumberContainer}
                                                    classNameInput={classes.inputNumber}
                                                    classLabel={classes.classLabel}
                                                    handleChangeInput={_ => { }}
                                                    onBlur={(e) => {
                                                        this.handleChangeLineNumber(minLines, maxLines, e.target.getValueAsNumber())
                                                    }
                                                    }
                                                />
                                            </div>
                                            {this.generateInputs(
                                                t('workPlan.selectOrgpathsOptional'),
                                                t('workPlan.selectOrgpaths'),
                                                exists(selectedOrgpath) ? selectedOrgpath : '',
                                                selectedWorkPlan.jobs,
                                                'selectedOrgpath',
                                                true,
                                                false,
                                                SingleValueOrgPath
                                            )}
                                            {this.generateInputs(
                                                t('workPlan.selectSchedulePatternTemplateOptional'),
                                                t('workPlan.selectSchedulePatternTemplate'),
                                                exists(selectedSchedulePatternTemplate) ? selectedSchedulePatternTemplate : '',
                                                schedulePatternsTemplates,
                                                'selectedSchedulePatternTemplate'
                                            )}
                                            {(selectedWorkPlan.states !== null && selectedWorkPlan.states.length === 0) ? '' :
                                                <React.Fragment>
                                                    <div style={{ width: '100%' }}>
                                                        {genDatePicker(classes, selectedStartDate === null ? undefined : selectedStartDate, "selectedStartDate", this.handleChangedate, this.props.t('workPlanView.addShiftLines.effectiveDate'), false, minDate, maxDate, undefined, (selectedWorkPlan.states !== null && selectedWorkPlan.states.length === 0))}
                                                    </div>
                                                    <div style={{ width: '100%', paddingTop: 8 }}>
                                                        {genDatePicker(classes, selectedEndDate === null ? undefined : selectedEndDate, "selectedEndDate", this.handleChangedate, this.props.t('workPlanView.addShiftLines.endDate'), false, minEndDate, maxDate, undefined, (selectedWorkPlan.states !== null && selectedWorkPlan.states.length === 0) || selectedStartDate === null, true)}
                                                    </div>
                                                </React.Fragment>
                                            }
                                            <div className={classes.divButtonApply}>
                                                <CustomButton disabled={
                                                    (selectedStartDate !== null && selectedEndDate === null)
                                                    || (selectedStartDate === null && selectedEndDate !== null)
                                                } color="primary" onClick={this.addShiftLines}>
                                                    {this.props.t('workPlanView.addShiftLines.apply')}
                                                </CustomButton>
                                            </div>
                                        </div>
                                    </ClickAwayListener>
                                </span>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedWorkPlan: state.selectedWorkPlan,
        schedulePatternsTemplates: state.schedulePatternsTemplates,
        isOpen: state.isAddShiftLineMenuOpen
    }
}

const mapDispatchToProps = {
    updateShiftLineMenuOpen
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(AddShiftLinesMenu)));